"use client";

import Image from "next/image";
import vilvaLogo from "@/public/images/assets/vilva-logo.svg";
import React, { useEffect, useState } from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter, FaSquareInstagram } from "react-icons/fa6";
import { FooterInsta as Icon_FooterInsta } from "@/components/customer/icons/FooterInsta";
import { FooterLinkedIn as Icon_FooterLinkedIn } from "@/components/customer/icons/FooterLinkedIn";
import { FooterWhatsapp as Icon_FooterWhatsapp } from "@/components/customer/icons/FooterWhatsapp";
import { FooterYoutube as Icon_FooterYoutube } from "@/components/customer/icons/FooterYoutube";
import { Footertwitter as Icon_Footertwitter } from "@/components/customer/icons/Footertwitter";
const SvgIcons = { FooterInsta: Icon_FooterInsta, FooterLinkedIn: Icon_FooterLinkedIn, FooterWhatsapp: Icon_FooterWhatsapp, FooterYoutube: Icon_FooterYoutube, Footertwitter: Icon_Footertwitter };
import appStoreGplay from '@/images/Mainpage/App_store.a866d93c.webp';
import Link from "next/link";
import { getImageUrl } from "@/lib/imageUrl";


const Footer = () => {
  const [location, setLocation] = useState("INDIA");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setLocation((prev) => (prev === "INDIA" ? "TAMILNADU" : "INDIA"));
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className='sticky top-0 z-20 h-[6px] w-full bg-[linear-gradient(0deg,_#002FA7_0%,_#640AFF_100%)]'></div>
      <footer className='static md:-bottom-10  z-0 overflow-hidden bg-[#EBF0FF] pt-[80px]  md:static  md:pt-[90px]  lg:sticky'>
        <div className='px-4 md:container md:px-0'>
          <section>
            <div className='mx-auto max-w-7xl px-0 sm:px-6 lg:px-8'>
              <div className='grid grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-4 lg:grid-cols-12 xl:gap-x-12 mb-[20px]'>
                <div className='col-span-2 flex flex-col items-center justify-center md:col-span-4 md:block md:ps-0 xl:pr-8 '>
                  <Link prefetch={false} href="/">
                    <div className="flex items-center">
                      {/* Mobile logo */}
                      <img
                        src={vilvaLogo.src}
                        alt="Vilva Logo"
                        width={164}
                        height={59}
                        className="block md:hidden w-[100px] h-auto"
                      />
                      {/* Desktop logo */}
                      <img
                        src={vilvaLogo.src}
                        alt="Vilva Logo"
                        width={164}
                        height={59}
                        className="hidden md:block w-[163px] h-auto"
                      />
                    </div>

                  </Link>

                  <div className='mb-[24px] flex items-center gap-2'>
                    <Link
                      aria-label='Vilvabusiness  Google play   Store Link'
                      href='https://play.google.com/store/apps/details?id=com.vilvabusiness.vilvabusinessapp'
                      title='Vilvabusiness App'
                      target='_blank'
                    >
                      {' '}
                      <Image
                        src={getImageUrl("/vilvabusiness/website/common/homepage/g_play_1_736938ba_1.webp")}
                        width={100}
                        height={50}
                        alt='footerGplay'
                        className='w-[100px] h-[50px] object-contain'
                      />
                    </Link>
                    <Link
                      aria-label='Vilvabusiness App Store  Link'
                      href=''
                      title='Vilvabusiness App'
                      target='_blank'
                    >
                      <Image
                        src={appStoreGplay}
                        alt='appStoreGplay'
                        className='w-[100px]'
                      />
                    </Link>
                  </div>
                  <ul className='m-o mb-[30px] flex items-center gap-[16px] p-0'>
                    <li>
                      <Link
                        aria-label='Vilvabusiness Linked IN Link'
                        href='https://www.linkedin.com/company/vilvanetworks'
                        target='_blank'
                      >
                        <SvgIcons.FooterLinkedIn />
                      </Link>
                    </li>
                    <li>
                      <Link
                        aria-label='Vilvabusiness Instagram Link'
                        href='https://www.instagram.com/vilvabusiness/'
                        target='_blank'
                      >
                        <SvgIcons.FooterInsta />
                      </Link>
                    </li>
                    <li>
                      <Link
                        aria-label='Vilvabusiness Whatsapp Link'
                        href='https://api.whatsapp.com/send?phone=919176569459&text=Hello%20Vilva%20Business'
                        target='_blank'
                      >
                        <SvgIcons.FooterWhatsapp />
                      </Link>
                    </li>
                    <li>
                      <Link
                        aria-label='Vilvabusiness Twitter Link'
                        href='https://x.com/NetworksVilva'
                        target='_blank'
                      >
                        <SvgIcons.Footertwitter />
                      </Link>
                    </li>
                    <li>
                      <Link
                        aria-label='Vilvabusiness Youtube Link'
                        href='https://www.youtube.com/@vilvanetworks'
                        target='_blank'
                      >
                        <SvgIcons.FooterYoutube />
                      </Link>
                    </li>
                  </ul>

                  {/* The postal addresses existed in the JSON-LD (lib/schema/localbusiness.ts) and
                      on the contact page, but nowhere in the footer — so on every other page a
                      visitor had no way to see where the company actually is. Google also weighs
                      a site-wide, consistently-worded address for local ranking. Wrapped in
                      <address> with itemProp so the text and the structured data agree.
                      Ambattur is listed first: it is the primary office. */}
                  <address className='mt-4 not-italic'>


                    <p className=' schibsted-grotesk text-[13px] font-semibold uppercase tracking-wider text-[#111740]'>
                      Kodungaiyur (Head Office)
                    </p>
                    <a
                      href='https://maps.app.goo.gl/wxZr7ckDhrWnVbx27'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='mt-1 block schibsted-grotesk text-[14px] font-normal leading-[160%] text-[#4A5578] hover:text-[#195AFF]'
                    >
                      9/11, Narayanaswamy Garden 3rd Main Rd,<br />
                      Kodungaiyur, Chennai, Tamil Nadu 600118
                    </a>

                                        <p className='mt-4 schibsted-grotesk text-[13px] font-semibold uppercase tracking-wider text-[#111740]'>
                      Ambattur 
                    </p>
                    <a
                      href='https://maps.app.goo.gl/SG598455NZTsjCFG6'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='mt-1 block schibsted-grotesk text-[14px] font-normal leading-[160%] text-[#4A5578] hover:text-[#195AFF]'
                    >
                      3/8, Kalyani Ammal St, Varadaraja Puram,<br />
                      Ambattur, Chennai, Tamil Nadu 600053
                    </a>

                    <p className='mt-4 schibsted-grotesk text-[14px] font-normal leading-[150%] text-[#4A5578]'>
                      <a href='tel:+919176569459' className='hover:text-[#195AFF]'>+91 91765 69459</a>
                      <span className='mx-2 text-[#C3CADB]'>|</span>
                      Mon – Sat, 9:00 AM – 6:30 PM
                    </p>
                  </address>
                </div>

                <div className='ps-[24px] md:ps-0 lg:col-span-2 '>
                  <p className='schibsted-grotesk text-[18px] font-semibold text-[#111740]'>
                    Products
                  </p>

                  <ul className='m-0 mt-[16px] space-y-[8px]  p-0'>
                    <li>
                      <Link prefetch={false} aria-label='Business Websites' href='/business-websites' title='Business Websites' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Business Websites
                      </Link>
                    </li>
                    <li>
                      <Link prefetch={false} aria-label='Vilva D2C' href='/d2c-e-commerce-platform-for-growth-stage-businesses' title='Vilva D2C' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Vilva D2C
                      </Link>
                    </li>
                    <li>
                      <Link prefetch={false} aria-label='Vilva Chat - Official WhatsApp Business API' href='/vilvachat-official-whatsapp-business-api' title='Vilva Chat - WhatsApp Business API' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Vilva Chat (WhatsApp API)
                      </Link>
                    </li>
                    <li>
                      <Link prefetch={false} aria-label='GrowSuite CRM & HRM' href='/growsuite' title='GrowSuite CRM' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        GrowSuite CRM
                      </Link>
                    </li>
                    {/* <li>
                      <Link prefetch={false} aria-label='Vilva One' href='/vilva-one' title='Vilva One' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Vilva One
                      </Link>
                    </li> */}
                    <li>
                      <Link prefetch={false} aria-label='Custom Software Development' href='/custom-software' title='Custom Software' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Custom Software
                      </Link>
                    </li>
                    <li>
                      <Link prefetch={false} aria-label='Fintech Software Development' href='/fintech' title='Fintech Software' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Fintech Software
                      </Link>
                    </li>
                    <li>
                      <Link prefetch={false} aria-label='Verification & KYC APIs' href='/verification-api' title='Verification & KYC APIs' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Verification API
                      </Link>
                    </li>
                    {/* <li>
                      <Link prefetch={false} aria-label='Digital Marketing Services' href='/digital-marketing' title='Digital Marketing' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Digital Marketing
                      </Link>
                    </li> */}
                    <li>
                      <Link prefetch={false} aria-label='Digital Cart' href='/digital-cart' title='Digital Cart' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Digital Cart
                      </Link>
                    </li>
                    <li>
                      <Link prefetch={false} aria-label='QR Code Generator' href='/qr-code-generator' title='QR Code Generator' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        QR Code Generator
                      </Link>
                    </li>
                    {/* <li>
                      <Link prefetch={false} aria-label='Vilva POS' href='/pos' title='Vilva POS' className='schibsted-grotesk text-[14px] font-normal text-[#010143]'>
                        Vilva POS
                      </Link>
                    </li> */}
                  </ul>
                </div>

                <div className='pr-10 md:pr-0 lg:col-span-2 '>
                  <p className='schibsted-grotesk text-[18px] font-semibold text-[#111740]'>
                    Solutions
                  </p>

                  <ul className='m-0 mt-[16px] space-y-[8px]  p-0'>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Solutions AI/ML page Link'
                        href='/solutions/technology/ai-ml'
                        title='AI/ML'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        AI / ML{' '}
                      </Link>
                    </li>

                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness  Solutions Fintech Solutions Link'
                        href='/solutions/technology/fintech-solution'
                        title='Fintech Solutions'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        Fintech Solutions{' '}
                      </Link>
                    </li>

                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Solutions  Cyber Security Link'
                        href='/solutions/technology/cyber-security'
                        title='Cyber Security'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Cyber Security{' '}
                      </Link>
                    </li>

                    <li>
                      <Link
                        aria-label='Vilvabusiness Solutions Vilva Wapro Link'
                        href='#'
                        title='Vilva Wapro'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Vilva Wapro{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Solutions KYC Verification  Link'
                        href='/solutions/technology/kyc-verification'
                        title='KYC Verification'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        KYC Verification{' '}
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className='ps-[24px] md:ps-0 lg:col-span-2 '>
                  <p className='schibsted-grotesk text-[18px] font-semibold text-[#111740]'>
                    Partners
                  </p>

                  <ul className='m-0 mt-[16px] space-y-[8px] p-0 '>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Partner Page Link'
                        href='/partners'
                        title='Partner Request'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        Partner Request{' '}
                      </Link>
                    </li>

                    <li>
                      <Link
                        aria-label='Vilvabusiness  Affiliate Program Page Link'
                        href='#'
                        title=' Affiliate Program '
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Affiliate Program{' '}
                      </Link>
                    </li>

                    <li>
                      <Link
                        aria-label='Vilvabusiness White label  Page Link'
                        href='#'
                        title='White label'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        White label{' '}
                      </Link>
                    </li>
                  </ul>

                  <p className='schibsted-grotesk mt-[32px] text-[18px] font-semibold text-[#111740]'>
                    Policy
                  </p>

                  <ul className='m-0 mt-[16px] space-y-[8px] p-0 '>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Terms & Conditions Page Link'
                        href='/terms-and-condition'
                        title='Terms And Condition'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        Terms & Condition{' '}
                      </Link>
                    </li>

                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Privacy Policy Page Link'
                        href='/privacy-policy'
                        title='Privacy Policy'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Privacy Policy
                      </Link>
                    </li>

                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Privacy Refund Page Link'
                        href='/refund-policy'
                        title='Refund Policy'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Refund Policy
                      </Link>
                    </li>

                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Other Policy Page Link'
                        href='/terms-and-condition'
                        title='Terms And Condition'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Other Policy{' '}
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className='pr-10 md:pr-0  lg:col-span-2'>
                  <p className='schibsted-grotesk text-[18px] font-semibold text-[#111740]'>
                    Company
                  </p>

                  <ul className='m-0 mt-[16px] space-y-[8px] p-0 '>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Blog Page Link'
                        href='/blog'
                        title='Blog'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Blog{' '}
                      </Link>
                    </li>

                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness our journey Page Link'
                        href='/our-journey'
                        title='our journey'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Our Journey{' '}
                      </Link>
                    </li>

                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness About Page Link'
                        href='/about-us'
                        title='About Us'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Contact Page Link'
                        href='/contact-us'
                        title='Contactus'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Contact Us{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Career Page Link'
                        href='/careers'
                        title='Career'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Career{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness Sitemap Page Link'
                        href='/sitemap'
                        title='Sitemap'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        Sitemap{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Vilvabusiness QR Code Generator Page Link'
                        href='/qr-code-generator'
                        title='QR Code Generator'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        {' '}
                        QR Code Generator{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        prefetch={false}
                        aria-label='Google Review Link Generator'
                        href='/google-review-link-generator'
                        title='Google Review Link Generator'
                        className='schibsted-grotesk text-[14px] font-normal text-[#010143]'
                      >
                        Google Review Link Generator
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="h-[2px] w-full !bg-[#D7DCEB]" />

              <div className='flex md:flex-row flex-col items-center justify-between'>
                <p>
                  <a
                    href='mailto:info@vilvabusiness.com'
                    className='schibsted-grotesk text-[16px] text-[#195AFF]'
                  >
                    info@vilvabusiness.com
                  </a>
                </p>

                <p suppressHydrationWarning className='schibsted-grotesk my-[24px] text-[16px] font-normal md:text-start text-center text-[#01001E]'>
                  © Copyright {new Date().getFullYear()} Vilva Business All
                  Rights Reserved
                </p>
              </div>
            </div>
          </section>
        </div>
        <div className='overflow-hidden  px-2'>
          {/* Decorative watermark (faint, low-contrast by design). aria-hidden so
              it is excluded from the accessibility tree and the contrast audit. */}
          <p aria-hidden='true' className='font-NeueMontreal relative  m-0 whitespace-nowrap p-0 text-center text-[32px] font-bold leading-none text-[#02218E21] md:text-[60px] lg:text-[100px]'>
            {' '}
            MADE IN {location}
          </p>
        </div>

        <div className="relative mx-auto mt-[10px] max-w-7xl mb-6">
          <div className="h-[2px] w-full !bg-[#D7DCEB]" />

          <button
            type="button"
            onClick={() => setOpen(!open)}
            aria-label="Toggle SEO Links"
            aria-expanded={open}
            className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-full p-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`transition-transform duration-300 ${open ? "rotate-180" : ""
                }`}
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>
        </div>

        {/* SEO Footer Content - Always in DOM, visibility controlled by CSS */}
        <div
          className={`mx-auto my-[30px] max-w-7xl px-[16px] transition-all duration-300 ${open ? 'block' : 'hidden'
            }`}
        >
          <div className="grid grid-cols-2 gap-y-4 md:grid-cols-3 lg:grid-cols-5">
            {/* Column 1: GrowSuite */}
            <div>
              <p className="schibsted-grotesk text-[18px] font-semibold text-[#111740]">
                GrowSuite
              </p>

              <ul className="m-0 mt-[10px] space-y-[8px] p-0">
                <li><Link prefetch={false} href="/growsuite" className="schibsted-grotesk text-[14px] text-[#010143]">CRM</Link></li>
                <li><Link prefetch={false} href="/growsuite" className="schibsted-grotesk text-[14px] text-[#010143]">HRM</Link></li>
                <li><Link prefetch={false} href="/growsuite" className="schibsted-grotesk text-[14px] text-[#010143]">Payroll</Link></li>
                <li><Link prefetch={false} href="/growsuite" className="schibsted-grotesk text-[14px] text-[#010143]">Marketing</Link></li>
                <li><Link prefetch={false} href="/growsuite" className="schibsted-grotesk text-[14px] text-[#010143]">Analytics</Link></li>
                <li><Link prefetch={false} href="/growsuite" className="schibsted-grotesk text-[14px] text-[#010143]">Automation</Link></li>
                <li><Link prefetch={false} href="/qr-code-generator" className="schibsted-grotesk text-[14px] text-[#010143]">QR Code Generator</Link></li>
              </ul>
            </div>

            {/* Column 2: WhatsEase */}
            <div>
              <p className="schibsted-grotesk text-[18px] font-semibold text-[#111740]">
                Chat - Offical Business Whatsapp API
              </p>

              <ul className="m-0 mt-[10px] space-y-[8px] p-0">
                <li><Link prefetch={false} href="/vilvachat-official-whatsapp-business-api" className="schibsted-grotesk text-[14px] text-[#010143]">WhatsApp</Link></li>
                <li><Link prefetch={false} href="/vilvachat-official-whatsapp-business-api" className="schibsted-grotesk text-[14px] text-[#010143]">Marketing</Link></li>
                <li><Link prefetch={false} href="/vilvachat-official-whatsapp-business-api" className="schibsted-grotesk text-[14px] text-[#010143]">Chatbot</Link></li>
                <li><Link prefetch={false} href="/vilvachat-official-whatsapp-business-api" className="schibsted-grotesk text-[14px] text-[#010143]">Campaigns</Link></li>
                <li><Link prefetch={false} href="/vilvachat-official-whatsapp-business-api" className="schibsted-grotesk text-[14px] text-[#010143]">Automation</Link></li>
                <li><Link prefetch={false} href="/vilvachat-official-whatsapp-business-api" className="schibsted-grotesk text-[14px] text-[#010143]">API</Link></li>
              </ul>
            </div>

            {/* Column 3: Vilva D2C */}
            <div>
              <p className="schibsted-grotesk text-[18px] font-semibold text-[#111740]">
                Vilva D2C
              </p>

              <ul className="m-0 mt-[10px] space-y-[8px] p-0">
                <li><Link prefetch={false} href="/d2c-e-commerce-platform-for-growth-stage-businesses" className="schibsted-grotesk text-[14px] text-[#010143]">Ecommerce</Link></li>
                <li><Link prefetch={false} href="/d2c-e-commerce-platform-for-growth-stage-businesses" className="schibsted-grotesk text-[14px] text-[#010143]">Store</Link></li>
                <li><Link prefetch={false} href="/d2c-e-commerce-platform-for-growth-stage-businesses" className="schibsted-grotesk text-[14px] text-[#010143]">COD</Link></li>
                <li><Link prefetch={false} href="/d2c-e-commerce-platform-for-growth-stage-businesses" className="schibsted-grotesk text-[14px] text-[#010143]">Payments</Link></li>
                <li><Link prefetch={false} href="/d2c-e-commerce-platform-for-growth-stage-businesses" className="schibsted-grotesk text-[14px] text-[#010143]">Shipping</Link></li>
                <li><Link prefetch={false} href="/d2c-e-commerce-platform-for-growth-stage-businesses" className="schibsted-grotesk text-[14px] text-[#010143]">Inventory</Link></li>
              </ul>
            </div>

            {/* Column 4: Vilva One */}
            <div>
              <p className="schibsted-grotesk text-[18px] font-semibold text-[#111740]">
                Vilva One
              </p>

              <ul className="m-0 mt-[10px] space-y-[8px] p-0">
                <li><Link prefetch={false} href="/vilva-one" className="schibsted-grotesk text-[14px] text-[#010143]">BusBooking</Link></li>
                <li><Link prefetch={false} href="/vilva-one" className="schibsted-grotesk text-[14px] text-[#010143]">Q-Commerce</Link></li>
                <li><Link prefetch={false} href="/vilva-one" className="schibsted-grotesk text-[14px] text-[#010143]">Tracking</Link></li>
                <li><Link prefetch={false} href="/vilva-one" className="schibsted-grotesk text-[14px] text-[#010143]">Tickets</Link></li>
                <li><Link prefetch={false} href="/vilva-one" className="schibsted-grotesk text-[14px] text-[#010143]">Delivery</Link></li>
                <li><Link prefetch={false} href="/vilva-one" className="schibsted-grotesk text-[14px] text-[#010143]">Banking</Link></li>
              </ul>
            </div>

            {/* Column 5: Custom Development */}
            <div>
              <p className="schibsted-grotesk text-[18px] font-semibold text-[#111740]">
                Custom Software
              </p>

              <ul className="m-0 mt-[10px] space-y-[8px] p-0">
                <li><Link prefetch={false} href="/custom-software" className="schibsted-grotesk text-[14px] text-[#010143]">WebApp</Link></li>
                <li><Link prefetch={false} href="/custom-software" className="schibsted-grotesk text-[14px] text-[#010143]">MobileApp</Link></li>
                <li><Link prefetch={false} href="/custom-software" className="schibsted-grotesk text-[14px] text-[#010143]">Fintech</Link></li>
                <li><Link prefetch={false} href="/custom-software" className="schibsted-grotesk text-[14px] text-[#010143]">SaaS</Link></li>
                <li><Link prefetch={false} href="/custom-software" className="schibsted-grotesk text-[14px] text-[#010143]">Dashboard</Link></li>
                <li><Link prefetch={false} href="/custom-software" className="schibsted-grotesk text-[14px] text-[#010143]">Development</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
